"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconJewelryWatchesThematic = void 0;
var React = __importStar(require("react"));
var IconJewelryWatchesThematic = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M12,21.001 C11.449,21.001 11,20.553 11,20.001 C11,19.449 11.449,19.001 12,19.001 C12.551,19.001 13,19.449 13,20.001 C13,20.553 12.551,21.001 12,21.001 M16,19.001 C15.724,19.001 15.5,18.776 15.5,18.501 C15.5,18.226 15.724,18.001 16,18.001 C16.276,18.001 16.5,18.226 16.5,18.501 C16.5,18.776 16.276,19.001 16,19.001 M8,19.001 C7.724,19.001 7.5,18.776 7.5,18.501 C7.5,18.226 7.724,18.001 8,18.001 C8.276,18.001 8.5,18.226 8.5,18.501 C8.5,18.776 8.276,19.001 8,19.001 M20.5,9.897 C20.5,6.428 18.298,3.267 15.021,2.033 C14.762,1.934 14.475,2.065 14.377,2.325 C14.28,2.583 14.411,2.872 14.669,2.969 C17.559,4.057 19.5,6.842 19.5,9.897 C19.5,13.984 16.136,17.309 12,17.309 C7.864,17.309 4.5,13.984 4.5,9.897 C4.5,6.843 6.44,4.059 9.328,2.97 C9.586,2.872 9.717,2.584 9.619,2.325 C9.521,2.067 9.234,1.935 8.975,2.034 C5.7,3.27 3.5,6.429 3.5,9.897 C3.5,12.933 5.138,15.589 7.58,17.068 C6.958,17.251 6.5,17.82 6.5,18.501 C6.5,19.328 7.173,20.001 8,20.001 C8.827,20.001 9.5,19.328 9.5,18.501 C9.5,18.283 9.451,18.077 9.367,17.891 C9.907,18.065 10.469,18.188 11.049,18.253 C10.428,18.592 10,19.244 10,20.001 C10,21.104 10.897,22.001 12,22.001 C13.103,22.001 14,21.104 14,20.001 C14,19.244 13.572,18.592 12.951,18.253 C13.531,18.188 14.093,18.065 14.633,17.891 C14.549,18.077 14.5,18.283 14.5,18.501 C14.5,19.328 15.173,20.001 16,20.001 C16.827,20.001 17.5,19.328 17.5,18.501 C17.5,17.82 17.042,17.251 16.42,17.068 C18.862,15.589 20.5,12.933 20.5,9.897" }))); };
exports.IconJewelryWatchesThematic = IconJewelryWatchesThematic;
exports.IconJewelryWatchesThematic.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconJewelryWatchesThematic;
